/**
 * Advisers slider script
 */
 class FinHub_AdvisersSlider {
  constructor() {
    this.initState();
    this.initEvents();
  }

  initState () {
    this.sliderWrapper = $('.block-advisers-slider');
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.block-advisers-slider__list');
    this.items = this.list.find('.block-advisers-slider__item');
    this.currentItem = 0;
    this.itemsPerPage = 4;
    this.animationInProgress = false;
  }

  initEvents() {
    this.initRWD();

    if (this.sliderWrapper.length) {
      this.initUI();
      this.list.attr('data-count', this.items.length);
    }
  }

  initUI () {        
    this.swipeEffect = new Hammer(this.sliderWrapper[0]);
    this.prevBtn.addClass('is-hidden');

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem === 0) {
        this.prevBtn.addClass('is-hidden');
      }

      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.nextBtn.removeClass('is-hidden');

      setTimeout(() => {
          this.animationInProgress = false;
      }, 250);
    });

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem === (this.items.length / 2) - 1) {
        this.nextBtn.addClass('is-hidden');
      }

      if (this.currentItem >= this.items.length) {
        this.currentItem = (this.items.length - 1);
      }

      this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
      this.prevBtn.removeClass('is-hidden');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        this.nextBtn.trigger('click');
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        this.prevBtn.trigger('click');
      }
    });
  }

  initRWD () {
    this.desktopViewport = window.matchMedia('(min-width: 1024px)');
    this.tabletViewport = window.matchMedia('(min-width: 560px) and (max-width: 1023px)');
    this.mobileViewport = window.matchMedia('(max-width: 559px)');
    if (this.desktopViewport.matches) this.updateViewports('desktop');
    if (this.tabletViewport.matches) this.updateViewports('tablet');
    if (this.mobileViewport.matches) this.updateViewports('mobile');
    this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
    this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
    this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);

    if (this.desktopViewport.matches) {
      this.itemsPerPage = 4;
    } else if (this.tabletViewport.matches) {
      this.itemsPerPage = 2;
    } else if (this.mobileViewport.matches) {
      this.itemsPerPage = 1;
    }

    this.desktopViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(4);
      }
    });

    this.tabletViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(2);
      }
    });

    this.mobileViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(1);
      }
    });
  }

  updateViewports (type) {
    if (this.currentViewport !== type) {
      this.currentItem = 0;
      this.list.css('margin-left', "0%");
      this.currentViewport = type;
    }
  }

  setItemsPerPage (numberOfItems) {
    this.currentItem = 0;
    this.itemsPerPage = numberOfItems;
    this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");  
  }
}